export default [{
    path: '/topic',
    name: 'topic',
    component: () => import('@/views/topic')
},
{
    path: '/topic/add',
    component: () => import('@/views/topic/add')
},
{
    path: '/topic/:id/',
    props: (route) => ({
        id:  Number(route.params.id),
        
    }),
    component: () => import('@/views/topic/detail')
},
{
    path: '/topic/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id),
       
    }),
    component: () => import('@/views/topic/edit')
},
]